export class RecaptchaResponseModel {
  Version: string;
  ResultContent: Content;
  StatusCode: number;
  ReasonPhrase: string;
  Headers: Header[];
  TrailingHeaders: any[];
  RequestMessage: RequestMessage;
  IsSuccessStatusCode: boolean;
}

export class Header {
  key: string;
  value: string[];
}

export class Content {
  headers: Header[];
}

export class MethodReturn {
  method: string;
}

export class RequestMessageContent {
  headers: Header[];
}

export class RequestMessage {
  version: string;
  versionPolicy: number;
  content: RequestMessageContent;
  method: MethodReturn;
  requestUri: string;
  headers: Header[];
  properties: { [key: string]: any };
  options: { [key: string]: any };
}

export class ResultContent {
  headers: Header[];
}
